// extracted by mini-css-extract-plugin
module.exports = {"paragraph":"style_paragraph__3rd7W","bold":"style_bold__1MxZb"};